/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress
 */
export interface ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress
     */
    AddressLine1Txt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress
     */
    AddressLine2Txt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress
     */
    CityNm?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress
     */
    ProvinceOrStateNm?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress
     */
    CountryCd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress
     */
    ForeignPostalCd?: string;
}

/**
 * Check if a given object implements the ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress interface.
 */
export function instanceOfExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSON(json: any): ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress {
    return ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSONTyped(json, false);
}

export function ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'AddressLine1Txt': !exists(json, 'AddressLine1Txt') ? undefined : json['AddressLine1Txt'],
        'AddressLine2Txt': !exists(json, 'AddressLine2Txt') ? undefined : json['AddressLine2Txt'],
        'CityNm': !exists(json, 'CityNm') ? undefined : json['CityNm'],
        'ProvinceOrStateNm': !exists(json, 'ProvinceOrStateNm') ? undefined : json['ProvinceOrStateNm'],
        'CountryCd': !exists(json, 'CountryCd') ? undefined : json['CountryCd'],
        'ForeignPostalCd': !exists(json, 'ForeignPostalCd') ? undefined : json['ForeignPostalCd'],
    };
}

export function ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressToJSON(value?: ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AddressLine1Txt': value.AddressLine1Txt,
        'AddressLine2Txt': value.AddressLine2Txt,
        'CityNm': value.CityNm,
        'ProvinceOrStateNm': value.ProvinceOrStateNm,
        'CountryCd': value.CountryCd,
        'ForeignPostalCd': value.ForeignPostalCd,
    };
}

